import React from "react";
import GameInstructionModal from "../GameInstructionModal";

const BlueRedTheShooterModal = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="The Shooter (Red/Blue)"
      gamePath="/userDashboard/game/red-and-blue-theshooter"
      icon="icon-park-outline:game-three"
      instructions={[
        "Wear red and blue glasses.",
        "Aim at the oncoming balls and shoot by clicking the mouse / trackpad.",
        "You can shift your position left and right using the keyboard arrow keys."
      ]}
      isBinocular={true}
    />
  );
};

export default BlueRedTheShooterModal;
